module.exports = __webpack_public_path__ + "static/media/amsh-signup.f806322b.svg";